import { render } from "./PermissionPage.vue?vue&type=template&id=3aeb8b44&scoped=true"
import script from "./PermissionPage.vue?vue&type=script&lang=js"
export * from "./PermissionPage.vue?vue&type=script&lang=js"

import "./PermissionPage.vue?vue&type=style&index=0&id=3aeb8b44&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aeb8b44"]])

export default __exports__